import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface VisaDetailFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
}

export function VisaDetailFields({
  profile,
  setProfile,
  readOnly
}: VisaDetailFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Visum Typ</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Welches Visum hast du beantragt?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.visa_status}
          onValueChange={(value) =>
            setProfile({ ...profile!, visa_status: value })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="fachkraft_anerkennung">
              Fachkraft in Anerkennung (§16d AufenthG)
            </SelectItem>
            <SelectItem value="anerkannte_fachkraft">
              Anerkannte Fachkraft (§18a / §18b AufenthG)
            </SelectItem>
            <SelectItem value="hilfskraft">
              Hilfskraft während der Anerkennung (§19c Abs. 1 i.V.m. §6 BeschV)
            </SelectItem>
            <SelectItem value="ausbildung">
              Berufsausbildung (§16a AufenthG)
            </SelectItem>
            <SelectItem value="sprachkurs">
              Sprachkurs vor Ausbildung (§16g AufenthG)
            </SelectItem>
            <SelectItem value="eu_blue_card">EU Blaue Karte</SelectItem>
            <SelectItem value="other">Andere</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">
            Termin bei der Botschaft
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Wann ist der Termin bei der deutschen Botschaft?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Input
          disabled={readOnly}
          type="date"
          value={
            profile?.visa_meeting_date
              ? new Date(profile.visa_meeting_date).toISOString().split("T")[0]
              : ""
          }
          onChange={(e) =>
            setProfile({
              ...profile,
              visa_meeting_date: e.target.value
                ? new Date(e.target.value).toISOString()
                : ""
            })
          }
          className="w-full"
        />
      </div>
    </div>
  );
}
